import { experimentSettings as experimentSettingNames } from "@/constants/experiments";

export function getExperimentSettingsFromExperimentList(experimentList) {
    return (
        experimentList
            .filter((x) => !!x.isActive)
            .map((x) => x.settings)
            .reduce((r, c) => Object.assign(r, c), {}) ?? {}
    );
}

export function getSettingValue(settingName, experimentSettings) {
    return hasSetting(settingName, experimentSettings) ? experimentSettings[settingName] : null;
}

export function hasSettingEqualTo(settingName, settingValue, experimentSettings) {
    return experimentSettings[settingName] == settingValue;
}

export function hasSetting(settingName, experimentSettings) {
    return Object.hasOwn(experimentSettings, settingName);
}

// Looks for an experiment setting that has a value that matches the passed in parent account number.
// Settings named NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT are excluded from the match.
export function hasClaimAndCoverage(parentAccountNumber, experimentList) {
    const parentNum = String(parentAccountNumber);
    return experimentList.some(
        (experiment) =>
            experiment.settings &&
            Object.entries(experiment.settings).some(
                ([name, value]) =>
                    name !== experimentSettingNames.NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT &&
                    value === parentNum
            )
    );
}

// hasClaimAndCoverage checks if the parent account number is in the experiment settings. Shared
// by insurance-company.js and navigation-helper.js so both places that decide between
// Heritage/Policy Info/Insurance Details agree on the same experiment checks.
export function isClaimAndCoverageExperimentActive(parentAccountNumber, experimentList) {
    return hasClaimAndCoverage(parentAccountNumber, experimentList);
}

// Non integrated experiment setting is true for everyone, send to the vue app Insurance Details
// page instead of Heritage.
export function isNonClaimAndCoverageFlowEnabled(experimentList) {
    const resolvedSettings = getExperimentSettingsFromExperimentList(experimentList);
    return hasSettingEqualTo(
        experimentSettingNames.ENABLE_NON_CLAIM_AND_COVERAGE_FLOW,
        "true",
        resolvedSettings
    );
}

// NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT contains a comma-separated list of specific parent
// account numbers to send to the vue app Insurance Details page, even when the non-integrated
// experiment setting above is off for everyone else.
export function isNonClaimAndCoverageTestParentAccount(parentAccountNumber, experimentList) {
    const resolvedSettings = getExperimentSettingsFromExperimentList(experimentList);
    const nonIntegratedTestParentAccount = getSettingValue(
        experimentSettingNames.NON_CLAIM_AND_COVERAGE_TEST_PARENT_ACCOUNT,
        resolvedSettings
    );
    const nonIntegratedTestParentAccounts = (nonIntegratedTestParentAccount ?? "")
        .toString()
        .split(",")
        .map((account) => account.trim())
        .filter((account) => account.length > 0);

    return nonIntegratedTestParentAccounts.includes(parentAccountNumber?.toString());
}
